





































import Vue, { PropType } from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions } from "vuex";
import * as a from "@/store/modules/ApplicationModule/actions";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { getImageFromModel_48 as getImageFromModel } from "@/utility/Constants";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
            search: "",
            openedTreeView: [],
        };
    },
    props: {
        customAttrs: {
            type: Number as PropType<LicenseModuleEnum>,
            default: LicenseModuleEnum.ServiceAndUpdatesManagement,
        },
    },
    computed: {
        ...mapState({
            modelTree: (state: RootState): string => state.application.modelTree,
        }),
        models() {
            if (this.modelTree) {
                let jsonModel = JSON.parse(this.modelTree);
                if (jsonModel && jsonModel.models && jsonModel.models.length) return jsonModel.models;
            }
            return [];
        },
        flattenedTree() {
            if (this.models) {
                let stack = [];
                let result = [];
                for (let root of this.models) {
                    stack.push(root);
                    while (stack.length > 0) {
                        let node = stack.pop();
                        result.push(node);
                        if (node.children) {
                            for (let child of node.children) {
                                stack.push(child);
                            }
                        }
                    }
                }
                return result;
            }
            return [];
        },
        flattenedTreeId() {
            if (this.flattenedTree && this.flattenedTree.length > 0) return this.flattenedTree.map((i) => i.id);
            return [];
        },
        openAll() {
            if (this.flattenedTree.length <= 10) return true;
            return false;
        },
    },
    watch: {
        selectedItems() {
            let selectedName = [];
            this.selectedItems.forEach((id) => {
                selectedName.push(this.flattenedTree.find((item) => item.id == id).name);
            });
            this.$emit("input", selectedName);
        },
        search() {
            if (this.search) this.openedTreeView = this.flattenedTreeId;
            else if (this.flattenedTree.length > 10) this.openedTreeView = [];
        },
    },
    methods: {
        ...mapActions([a.GET_MODEL_TREE]),
        getImageFromModel,
    },
    async mounted() {
        this.loading = true;
        if (!this.modelTree) await this[a.GET_MODEL_TREE]();
        this.loading = false;
    },
});
